import { render, staticRenderFns } from "./LanguagesBar.vue?vue&type=template&id=7b1b361b"
import script from "./LanguagesBar.vue?vue&type=script&lang=js"
export * from "./LanguagesBar.vue?vue&type=script&lang=js"
import style0 from "./LanguagesBar.vue?vue&type=style&index=0&id=7b1b361b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports